import Styled from "styled-components";
import { Card } from 'antd';

export const CardHeader = Styled.div`

    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: right;
    font-size: 1rem;

`

export const AnswerCard = Styled(Card)`

    width: 95%;

`